import styled from 'styled-components'
import reactStringReplace from 'react-string-replace'

import { palette, fonts, mediaQueries } from '../../styles/variables'
import { translate } from '../../utils/translation'
import { PrimaryButton, LinkButton, CloseButton } from '../buttons/Buttons'
import { Text } from '../topography'
import Icon from '../icon/Icon'
import warning from '../../styles/assets/warning-small.svg'
import checkGreen from '../../styles/assets/circle_check_green_fill.svg'

import Modal, { ModalHeader, ModalContent, ModalFooter } from './Modal'

const Title = styled.span({
  color: palette.darkGray,
  fontSize: 24,
  fontFamily: fonts.primaryBook,
  textAlign: 'center',
  marginLeft: '8px',
  [mediaQueries.mobile]: {
    fontSize: '18px',
    marginLeft: 0,
    marginTop: 20,
    transform: 'translateX(0)',
  },
})

const Row = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [mediaQueries.mobile]: {
    flexDirection: 'column',
  },
})

const desktopStyle = {
  width: '504px',
}

const mobileStyle = {
  width: '90%',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
}

const FooterSection = styled.div({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',

  '& button': {
    [mediaQueries.mobile]: {
      marginTop: '15px',
    },
  },
})

const EmailConfirmModal = ({
  email = '',
  onSubmit,
  onClose,
  isOpen,
  isSentEmail,
  hideCloseIcon,
  ...rest
}) => (
  <Modal
    isOpen={isOpen}
    desktopStyle={desktopStyle}
    mobileStyle={mobileStyle}
    overlayStyle={{ zIndex: 100000 }}
    parentSelector={() =>
      document.getElementById('prompt-modal-create-project')
    }
    {...rest}
  >
    <ModalHeader doubleBorder>
      <Row>
        <Icon src={warning} transform="translateX(-50%)" />
        <Title>{translate('confirm_email_modal_heading')}</Title>
        {!hideCloseIcon && (
          <CloseButton onClick={onClose} style={{ top: 20 }} />
        )}
      </Row>
    </ModalHeader>
    <ModalContent style={{ height: 'calc(100% - 200px)' }}>
      <Text
        color={palette.darkGray}
        fontFamily={fonts.primary}
        textAlign="center"
        fontSize="12px"
        lineHeight="26px"
        mobilePadding="0 20px"
        boldColor={palette.darkGray}
        dangerouslySetInnerHTML={{
          __html: translate('confirm_email_modal_text', email),
        }}
      />
      <Text
        color={palette.darkGray70}
        fontFamily={fonts.primary}
        textAlign="center"
        fontSize="12px"
        lineHeight="26px"
        mobilePadding="0 20px"
      >
        {translate('confirm_email_modal_note')}
      </Text>
    </ModalContent>
    <ModalFooter>
      <FooterSection>
        {isSentEmail ? (
          <div>
            <div
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Icon src={checkGreen} margin="0 8px 0 0" />
              <Text lineHeight="20px" margin="4px 0 0 0">
                {translate('email_confirmation_sent')}
              </Text>
            </div>

            <Text lineHeight="26px" margin="12px 0 0 0">
              {reactStringReplace(
                translate('refresh_email_confirmed', translate('refresh_page')),
                translate('refresh_page'),
                (match, index) => {
                  return (
                    <LinkButton
                      key={index}
                      style={{
                        textDecoration: 'underline',
                        fontSize: '14px',
                        lineHeight: '26px',
                        margin: '0px',
                        display: 'inline-block',
                        fontFamily: fonts.primaryBook,
                        letterSpacing: '0px',
                      }}
                      onClick={() => window.location.reload()}
                    >
                      {match}
                    </LinkButton>
                  )
                },
              )}
            </Text>
          </div>
        ) : (
          <PrimaryButton
            theme="orange"
            onClick={onSubmit}
            style={{
              fontSize: '14px',
              flex: 1,
              maxWidth: 'fit-content',
            }}
            tag={translate('resend_confirmation_button')}
          />
        )}
      </FooterSection>
    </ModalFooter>
  </Modal>
)

export default EmailConfirmModal
